import { render, staticRenderFns } from "./TranslationList.vue?vue&type=template&id=b68a6346"
import script from "./TranslationList.vue?vue&type=script&lang=js"
export * from "./TranslationList.vue?vue&type=script&lang=js"
import style0 from "./TranslationList.vue?vue&type=style&index=0&id=b68a6346&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68a6346')) {
      api.createRecord('b68a6346', component.options)
    } else {
      api.reload('b68a6346', component.options)
    }
    module.hot.accept("./TranslationList.vue?vue&type=template&id=b68a6346", function () {
      api.rerender('b68a6346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/translations/TranslationList.vue"
export default component.exports